import { render, staticRenderFns } from "./AuthToken.vue?vue&type=template&id=820a0528&scoped=true&"
import script from "./AuthToken.vue?vue&type=script&lang=js&"
export * from "./AuthToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820a0528",
  null
  
)

export default component.exports